// AI controller contract: plane drives itself by computing InputState each tick.
// Real behavior tree implementation lands in P3; P2 ships DummyController.

import type { Plane } from '../plane/Plane';
import type { InputState } from '../core/Input';
import type { PersonalityId } from './personalities';

export interface AIWorldRef {
  planes: Plane[];                       // all planes including self
  now: number;                           // game time seconds
  fire: (owner: Plane) => void;          // helper to spawn a bullet
}

export interface AIController {
  plane: Plane;
  personalityId: PersonalityId;
  callsign: string;
  update(dt: number, world: AIWorldRef): InputState;
}

// Used as a stand-in input slate; controllers mutate fields and return.
export const ZERO_INPUT: InputState = {
  pitch: 0, yaw: 0, roll: 0, throttle: 0.7, boost: false, fire: false, firePulse: false, brake: false,
};

export function blankInput(): InputState {
  return { ...ZERO_INPUT };
}
